import { getApv, postApv } from '../../apis';
import { SDK_DOMAIN } from '../../constants';
import {
  closeBottomSheet,
  getIframe,
  setAddEventListener,
  setBottomSheet,
  setIframeInnerHtml,
  setNumericOnly,
  stringToHTML,
} from '../../helpers';
import { setAlertModal, showAlertModal } from '../components/alert';

const CashReceipt = {
  // Constant
  value: {
    cashEntyno: '',
    cashIssInf: '',
    cashIssMtd: '',
    cashIssMtdName: '',
  },
  mtdCodeList: [],

  render: async () => {
    setAlertModal();

    try {
      // initialize
      const cashReceiptIss = await getApv(
        'common/code?grpCode=CASH_RECEIPT_ISS_MTD'
      );
      if (cashReceiptIss == null)
        throw '데이터 로드 중입니다.\n잠시 후 시도해 보세요 (1001)';
      CashReceipt.mtdCodeList = cashReceiptIss;
    } catch (e) {
      showAlertModal('오류', e.resultMessage || e);
      console.error(e.resultMessage || e);
    }

    const cashInfoResult = await getApv('cash/getCashInfo');
    CashReceipt.value.cashEntyno = cashInfoResult?.cashEntyno ?? '';
    CashReceipt.value.cashIssInf = cashInfoResult?.cashIssInf ?? '';
    CashReceipt.value.cashIssMtd = cashInfoResult?.cashIssMtd ?? '';
    CashReceipt.value.cashIssMtdName = cashInfoResult?.cashIssMtdName ?? '';

    let initLabel = '선택해주세요';
    for (const item of CashReceipt.mtdCodeList) {
      if (item.codeId === CashReceipt.value.cashIssMtd) {
        initLabel = item.codeName;
        break;
      }
    }

    return `
        <div>
          <a id="connect_pay_back_button" class="c_back"></a>
        </div>
            <div class="c_title1">현금영수증 설정</div>
        <div class="form-group m_b_20">
            <label class="c_label1">발급방법</label>
            <div class="c_bod1 c_box skin1_bod" id="cash_method" >
                <div class="c_label4_3" id="cash_label" >${initLabel}</div>
                <a href="javascript:void(0)" class="c_more1"><img src="${SDK_DOMAIN}/images/icon_more.svg" /></a>
            </div>
        </div>
        <div class="form-group m_b_20">
            <label class="c_label1">발급번호</label>
            <input type="text" pattern="[0-9]*" inputmode="numeric" class="form-control c_input1 skin1_input" id="cash_input" placeholder="휴대폰번호" maxlength="11">
            <section class="m_t_10 text-black-50"></section>
        </div>
        <div class="m_t_10">
                <span class="c_label5_1">
                - 등록된 정보로 현금영수증이 발급됩니다.
                </span>
            </div>
        <div class="bottom_btn_wrapper">
            <button id="cash_receipt_save" class="btn c_btn1 skin1_btn">저장</button>
        </div>
    `;
  },

  afterRender: async () => {
    // Functions
    setNumericOnly('cash_input');
    // setAlertModal
    setAlertModal();

    const onClickReceiptListItem = (code) => {
      CashReceipt.value.cashIssMtd = code;

      for (const item of CashReceipt.mtdCodeList) {
        if (item.codeId === code) {
          getIframe().getElementById('cash_label').innerText = item.codeName;
          getIframe()
            .getElementById('cash_input')
            .setAttribute('maxlength', item.ref1);
          getIframe()
            .getElementById('cash_input')
            .setAttribute('placeholder', item.ref2);
          getIframe().getElementById('cash_input').value = '';
          break;
        }
      }

      getIframe()
        .querySelectorAll('#receipt_list > div')
        .forEach((element) => {
          element.className =
            element.id === code ? 'item c_label6' : 'item c_label6_1';
        });

      closeBottomSheet('cash_method');
    };

    const onClickCashReceiptSave = () => {
      CashReceipt.value.cashIssInf =
        getIframe().getElementById('cash_input').value;
      const search = {
        cashIssInf: CashReceipt.value.cashIssInf,
        cashIssMtd: CashReceipt.value.cashIssMtd,
        cashIssMtdName: CashReceipt.value.cashIssMtdName,
      };

      postApv('cash/cashReg', search)
        .then((res) => {
          showAlertModal('알림', '현금영수증 발급정보를 저장했습니다.', () => {
            history.back();
          });
        })
        .catch((err) => {
          showAlertModal('오류', err.resultMessage);
          console.error(err.resultMessage);
        });
    };

    //drawFunctions
    const drawCashMethod = async () => {
      const modalLayer = `<div class="modal c_btm1" id="cash_method_content">
                              <div class="modal-dialog">
                                  <div class="modal-content">
                                      <div class="modal-header">
                                          <h5 class="modal-title">발급방법</h5>
                                          <button type="button" class="close">
                                              <span aria-hidden="true">&times;</span>
                                          </button>
                                      </div>
                                      <div class="modal-body" id="receipt_list" />
                                  </div>
                              </div>
                          </div>`;

      stringToHTML(modalLayer).children[0].appendAfter(
        getIframe().getElementById('layer-wrapper')
      );

      let receiptListHtml = '';
      for (const item of CashReceipt.mtdCodeList) {
        let className = '';
        if (item.codeId === CashReceipt.value.cashIssMtd) {
          getIframe().getElementById('cash_label').innerText = item.codeName;
          getIframe().getElementById('cash_input').value =
            CashReceipt.value.cashIssInf;
          getIframe()
            .getElementById('cash_input')
            .setAttribute('placeholder', item.ref2);
          getIframe()
            .getElementById('cash_input')
            .setAttribute('maxlength', item.ref1);
          className = 'item c_label6';
        } else {
          className = 'item c_label6_1';
        }
        receiptListHtml += `<div class="${className}" value="${item.codeId}" id="${item.codeId}">${item.codeName}</div>`;
      }

      setIframeInnerHtml('receipt_list', receiptListHtml);
      setBottomSheet('cash_method');
    };

    //View Draw
    await drawCashMethod();

    // SetEvents
    setAddEventListener('cash_receipt_save', () => {
      onClickCashReceiptSave();
    });
    setAddEventListener('connect_pay_back_button', () => history.back());
    getIframe()
      .querySelectorAll('#receipt_list > div')
      .forEach((element) => {
        element.addEventListener('click', () => {
          onClickReceiptListItem(element.getAttribute('value'));
        });
      });
  },
};
export default CashReceipt;
